import styled from 'styled-components';
import { Text } from 'recharts';
import { getColorShade, getSizeBy, getFontFamily } from '../../../../src/styled/utils';
export const LegendList = styled.ul `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ $justifyContent = 'center' }) => $justifyContent};
`;
export const StyledLegendListItem = styled.li `
  margin-right: ${getSizeBy(5)};
  padding: ${getSizeBy(0.5)} 0;

  & > h6,
  svg {
    display: inline-block;
  }

  & > svg {
    margin-right: 7px;
  }
`;
export const StyledTickText = styled(Text) `
  & > tspan {
    font-weight: 600;
    font-size: ${getSizeBy(2)};
    font-family: ${getFontFamily('primary')};
    line-height: ${getSizeBy(3)};
    letter-spacing: ${getSizeBy(0.125)};
    fill: ${getColorShade('onSurface', 'mediumEmphasis')};
  }
`;
